import isArrayLike from 'is-array-like';

function toArray(args, start) {
  if (!isArrayLike(args) && args !== '') {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    throw new TypeError("".concat(args, " can't be converted to array."));
  }

  if (start == null) {
    start = 0;
  }

  if (typeof start !== 'number' || !Number.isFinite(start)) {
    throw new TypeError("".concat(start, " is not a valid start point."));
  }

  var len = args.length;

  if (start < 0) {
    start += len;
  }

  var argsObj = Object(args);
  var result = new Array(len - start);

  for (var i = start; i < len; i++) {
    if (i in argsObj) {
      result[i - start] = argsObj[i];
    }
  }

  return result;
}

export default toArray;
//# sourceMappingURL=args-to-arr.mjs.map
